import postalOperatorsMapper from '../../mapper-filter/operatorImpcMapper';
import {
  RETRIEVE_ALL_RIGHT_OPERATORS_SUCCESS,
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_SUCCESS,
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_SUCCESS,
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_SUCCESS,
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS,
  RIGHT_MAIL_PROCESSING_CENTER_CHECKED,
  RIGHT_POSTAL_OPERATOR_CHECKED,
  RIGHT_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_RIGHT_POSTAL_OPERATORS,
  SET_SELECTED_OPERATOR_IMPC_ON_TABLE,
  SWAP_TREES,
  UNSELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS,
  UNSELECT_ALL_RIGHT_POSTAL_OPERATORS,
} from '../actions/types/OperatorImpcActionTypes';
import operatorMapper from '../../mapper-filter/operatorMapper';
import filterIMPCCodesIfExistsInPostalOperators from '../../mapper-filter/filterImpc';
import { RESET_ASSET_TYPE, SET_ASSET_TYPE } from '../../../../asset-types/redux/actions/types/AssetTypesActionTypes';

export const initialState = {
  nodes: [],
  checkedPostalOperators: [],
  checkedMailProcessingCenters: [],
  expandedAllOperators: [],
  selections: [],
  selectedOperator: '',
  selectedImpc: '',
};
const allChildNodeValues = (nodes) => nodes.map((node) => node.children.map((mPC) => mPC.value))
  .reduce((initial, impcCodes) => initial.concat(impcCodes));

export const rightOperatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS:
      case RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_SUCCESS:
        case RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS:
      return {
        ...state,
        nodes: postalOperatorsMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_RIGHT_OPERATORS_BY_ROLE_SUCCESS: case RETRIEVE_ALL_RIGHT_OPERATORS_SUCCESS:
      return {
        ...state,
        nodes: operatorMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_SUCCESS: case RIGHT_MAIL_PROCESSING_CENTER_CHECKED:
      return {
        ...state,
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          action.payload,
          state.nodes,
        ),
      };
    case RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_SUCCESS:
      return {
        ...state,
        checkedPostalOperators: state.nodes.filter((operator) => action.payload.includes(operator.value)).map((item) => item.value),
      };
    case RIGHT_POSTAL_OPERATOR_CHECKED:
      return {
        ...state,
        checkedPostalOperators: action.payload,
      };
    case RIGHT_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedAllOperators: [...action.expandedAllOperators],
      };
    case SELECT_ALL_RIGHT_POSTAL_OPERATORS:
      return {
        ...state,
        checkedPostalOperators: allChildNodeValues(action.payload.nodes),
      };
    case SELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: allChildNodeValues(action.payload.nodes),
      };
    case UNSELECT_ALL_RIGHT_POSTAL_OPERATORS:
      return {
        ...state,
        checkedPostalOperators: [],
      };
    case UNSELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    case SET_SELECTED_OPERATOR_IMPC_ON_TABLE:
      return {
        ...state,
        selectedOperator: action.selectedOperator,
        selectedImpc: action.selectedImpc,
      };
    case SWAP_TREES:
      return {
        ...state,
        nodes: action.payload.newRight.nodes,
        checkedMailProcessingCenters: action.payload.newRight.checkedMailProcessingCenters,
        expandedPostalOperators: action.payload.newRight.expandedPostalOperators,
      };
    case SET_ASSET_TYPE: case RESET_ASSET_TYPE:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    default:
      return state;
  }
};
